import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { class: "__report-lesson px-12 md-down:px-4 pb-30" }
const _hoisted_2 = { class: "__report-lesson__header pt-10 flex flex-nowrap justify-between md-down:flex-col md-down:gap-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "mr-3 h-6 w-6",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.0867744 6.22202C0.440527 4.66346 1.83439 3.5 3.5 3.5H24.5C26.1656 3.5 27.5595 4.66346 27.9132 6.22202L14 14.7245L0.0867744 6.22202ZM0 8.2199V20.651L10.1556 14.4261L0 8.2199ZM11.8325 15.4508L0.335774 22.4978C0.897057 23.6815 2.10294 24.5 3.5 24.5H24.5C25.8971 24.5 27.1029 23.6815 27.6642 22.4978L16.1675 15.4508L14 16.7755L11.8325 15.4508ZM17.8444 14.4261L28 20.651V8.2199L17.8444 14.4261Z",
      fill: "#65758B"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Thông báo ")
], -1)
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 3.66797C1 3.11568 1.44772 2.66797 2 2.66797H14C14.5523 2.66797 15 3.11568 15 3.66797C15 4.22025 14.5523 4.66797 14 4.66797H2C1.44772 4.66797 1 4.22025 1 3.66797Z\" fill=\"#94A3B8\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.33203 8C2.33203 7.44772 2.77975 7 3.33203 7H12.6654C13.2176 7 13.6654 7.44772 13.6654 8C13.6654 8.55228 13.2176 9 12.6654 9H3.33203C2.77975 9 2.33203 8.55228 2.33203 8Z\" fill=\"#94A3B8\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.33203 12C4.33203 11.4477 4.77975 11 5.33203 11H10.6654C11.2176 11 11.6654 11.4477 11.6654 12C11.6654 12.5523 11.2176 13 10.6654 13H5.33203C4.77975 13 4.33203 12.5523 4.33203 12Z\" fill=\"#94A3B8\"></path></svg><div class=\"ml-1.5 font-semibold text-neutral-600 whitespace-nowrap\"> Bộ lọc </div>", 2)
const _hoisted_7 = [
  _hoisted_5
]
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "7",
  height: "7",
  viewBox: "0 0 7 7",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  width: "7",
  height: "7",
  viewBox: "0 0 7 7",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  width: "7",
  height: "7",
  viewBox: "0 0 7 7",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "mb-10" }
const _hoisted_20 = { class: "border-b border-neutral-200" }
const _hoisted_21 = {
  class: "flex space-x-8 tabs",
  "aria-label": "Tabs"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "__report-lesson__container"
}
const _hoisted_24 = { class: "mb-3 text-neutral-600 font-bold text-lg" }
const _hoisted_25 = { class: "grid gap-8 mb-10 md-down:gap-4 grid-cols-2 md-down:grid-cols-1" }
const _hoisted_26 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center flex-nowrap" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.4729 3.29087L12.4819 17.2255C12.4224 17.3902 12.2661 17.4999 12.091 17.5H11.9579C11.7945 17.5 11.6457 17.4061 11.5752 17.2587L9.61212 13.0992C9.32305 12.4859 9.43494 11.7586 9.89494 11.2606L12.3904 8.53194C12.5436 8.37126 12.5436 8.1186 12.3904 7.95792L12.0743 7.64179C11.9137 7.48861 11.661 7.48861 11.5004 7.64179L8.77198 10.1375C8.27405 10.5976 7.54681 10.7095 6.93364 10.4204L2.77451 8.45707C2.61412 8.39667 2.50582 8.24569 2.50001 8.07439V7.94128C2.48528 7.7541 2.59775 7.58026 2.77451 7.517L16.7076 2.5255C16.8574 2.47049 17.0255 2.50605 17.1401 2.61701L17.3564 2.83331C17.4864 2.94689 17.5327 3.12896 17.4729 3.29087Z",
      fill: "#2AA797"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm ml-2" }, " Thông báo đã gửi ")
], -1)
const _hoisted_28 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_29 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_30 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg width=\"21\" height=\"20\" viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1704:5253)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z\" fill=\"#94A3B8\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z\" fill=\"#94A3B8\"></path></g><defs><clipPath id=\"clip0_1704:5253\"><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(0.332031)\"></rect></clipPath></defs></svg><div class=\"text-neutral-500 text-sm ml-2\"> Thông báo đang soạn </div></div>", 1)
const _hoisted_32 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_33 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_34 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_35 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_36 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_37 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Tiêu đề "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Trạng thái "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Đồi tượng "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " PH Đã xem "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Ngày tạo "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Ngày Gửi ")
  ])
], -1)
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "px-3 py-4 text-center text-neutral-700" }
const _hoisted_41 = {
  class: "px-3 py-4 text-neutral-700 cursor-pointer",
  style: {"max-width":"200px"}
}
const _hoisted_42 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_43 = { class: "ml-6" }
const _hoisted_44 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_45 = {
  key: 1,
  style: {"color":"#e37056"},
  class: "flex items-center gap-2 font-semibold"
}
const _hoisted_46 = {
  key: 2,
  class: "flex items-center gap-2 font-semibold text-green-500"
}
const _hoisted_47 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_48 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_49 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  height: "250",
  width: "250"
}, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}, " Không có thông báo ", -1)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  key: 0,
  class: "__report-lesson__container"
}
const _hoisted_61 = { class: "mb-3 text-neutral-600 font-bold text-lg" }
const _hoisted_62 = { class: "grid gap-8 mb-10 md-down:gap-4 grid-cols-2 md-down:grid-cols-1" }
const _hoisted_63 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center flex-nowrap" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.4729 3.29087L12.4819 17.2255C12.4224 17.3902 12.2661 17.4999 12.091 17.5H11.9579C11.7945 17.5 11.6457 17.4061 11.5752 17.2587L9.61212 13.0992C9.32305 12.4859 9.43494 11.7586 9.89494 11.2606L12.3904 8.53194C12.5436 8.37126 12.5436 8.1186 12.3904 7.95792L12.0743 7.64179C11.9137 7.48861 11.661 7.48861 11.5004 7.64179L8.77198 10.1375C8.27405 10.5976 7.54681 10.7095 6.93364 10.4204L2.77451 8.45707C2.61412 8.39667 2.50582 8.24569 2.50001 8.07439V7.94128C2.48528 7.7541 2.59775 7.58026 2.77451 7.517L16.7076 2.5255C16.8574 2.47049 17.0255 2.50605 17.1401 2.61701L17.3564 2.83331C17.4864 2.94689 17.5327 3.12896 17.4729 3.29087Z",
      fill: "#2AA797"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm ml-2" }, " Thông báo đã gửi ")
], -1)
const _hoisted_65 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_66 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_67 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg width=\"21\" height=\"20\" viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1704:5253)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z\" fill=\"#94A3B8\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z\" fill=\"#94A3B8\"></path></g><defs><clipPath id=\"clip0_1704:5253\"><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(0.332031)\"></rect></clipPath></defs></svg><div class=\"text-neutral-500 text-sm ml-2\"> Thông báo đang soạn </div></div>", 1)
const _hoisted_69 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_70 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_71 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_72 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_73 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_74 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Tiêu đề "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Trạng thái "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Đồi tượng "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " TLV Đã xem "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Ngày tạo "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Ngày Gửi ")
  ])
], -1)
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "px-3 py-4 text-center text-neutral-700" }
const _hoisted_78 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700 cursor-pointer" }
const _hoisted_79 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_80 = { class: "ml-6" }
const _hoisted_81 = {
  key: 0,
  class: "flex items-center gap-2 font-semibold text-green-500"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", null, "Đã gửi", -1)
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", null, "Bản nháp", -1)
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_88 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_89 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_96 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  height: "250",
  width: "250"
}, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}, " Không có thông báo ", -1)
const _hoisted_98 = [
  _hoisted_96,
  _hoisted_97
]
const _hoisted_99 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideOverFilter = _resolveComponent("SideOverFilter")!
  const _component_DaInfinityLoading = _resolveComponent("DaInfinityLoading")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.sideOverShow ? 'side-over--active' : '')
    }, [
      (_ctx.sideOverShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sideOverShow = false))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_SideOverFilter, {
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sideOverShow = false)),
        onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterSubmit($event))),
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterSubmit($event))),
        isStaffs: _ctx.tab === 1
      }, null, 8, ["isStaffs"])
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$router.push('/notifications/create')), ["stop"])),
            type: "button",
            class: "h-12 button-p btn--ghost text-center mr-3 px-6 whitespace-nowrap"
          }, " Tạo thông báo mới "),
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sideOverShow = true)),
            class: "w-30 bg-white p-3 rounded-md border shadow-sm border-neutral-200 cursor-pointer flex items-center"
          }, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.filter?.state === 'completed')
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _createTextVNode(" Thông báo đã gửi "),
              _createElementVNode("button", {
                type: "button",
                class: "flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterSubmit({ state: '' })))
              }, _hoisted_11)
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter?.state === 'draft')
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
              _createTextVNode(" Thông báo nháp "),
              _createElementVNode("button", {
                type: "button",
                class: "flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterSubmit({ state: '' })))
              }, _hoisted_14)
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter?.day_care_class_id)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
              _createTextVNode(_toDisplayString(_ctx.filter?.className) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                class: "flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.filterSubmit({ day_care_class_id: null })))
              }, _hoisted_17)
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("nav", _hoisted_21, [
                  _createElementVNode("div", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.tab = 0)),
                    class: _normalizeClass(["order-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap pb-6 pt-4 px-1 font-semibold cursor-pointer", 
								_ctx.tab === 0
									? 'border-b-2 text-yellow-700 border-yellow-500'
									: 'text-neutral-500'
							])
                  }, " Dành cho phụ huynh ", 2),
                  _createElementVNode("div", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.tab = 1)),
                    class: _normalizeClass(["order-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap pb-6 pt-4 px-1 font-semibold cursor-pointer", 
								_ctx.tab === 1
									? 'border-b-2 text-yellow-700 border-yellow-500'
									: 'text-neutral-500'
							])
                  }, " Dành cho TLV ", 2)
                ])
              ])
            ]),
            (_ctx.tab === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_ctx.notificationList && _ctx.notificationList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationList, (lesson) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: lesson.date,
                            class: "mb-10"
                          }, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(lesson.tag), 1),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _hoisted_27,
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, _toDisplayString(lesson.sent_count || 0), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, _toDisplayString(lesson.draft_count || 0), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("table", _hoisted_37, [
                                    _hoisted_38,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lesson.notices, (item, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          onClick: _withModifiers(($event: any) => (
													_ctx.$router.push(
														`/notifications/${item?.id}`
													)
												), ["stop"]),
                                          key: item.id,
                                          class: _normalizeClass([
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												, "text-neutral-700 cursor-pointer hover:bg-orange-50"])
                                        }, [
                                          _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_40, _toDisplayString(index + 1), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_41, [
                                            _createElementVNode("div", null, _toDisplayString(item?.title), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                              (
																item.state ===
																'draft'
															)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Bản nháp "))
                                                : (
																item.state ===
																'withdrawn'
															)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, " Đã thu hồi "))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_46, " Đã gửi "))
                                            ])
                                          ]),
                                          _createElementVNode("td", _hoisted_47, [
                                            _createElementVNode("div", null, _toDisplayString(item?.subject), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_48, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("span", null, _toDisplayString(item.view_count ||
																'0') + " / " + _toDisplayString(item.total_parent_received ||
																'0'), 1)
                                            ])
                                          ]),
                                          _createElementVNode("td", _hoisted_49, [
                                            (item?.inserted_at)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.$filters.formatDateDDMM(
																item?.inserted_at
															)), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_51, "-"))
                                          ]),
                                          _createElementVNode("td", _hoisted_52, [
                                            (item?.sent_at)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.$filters.formatDateDDMM(
																item?.sent_at
															)), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_54, "-"))
                                          ])
                                        ], 10, _hoisted_39))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        }), 128)),
                        (_ctx.isInfinityLoading)
                          ? (_openBlock(), _createBlock(_component_DaInfinityLoading, {
                              key: 0,
                              onInfiniteLoad: _ctx.getNotificationList,
                              loaded: _ctx.stopLoad
                            }, null, 8, ["onInfiniteLoad", "loaded"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_58))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  (
						_ctx.notificationListForStaff &&
						_ctx.notificationListForStaff.length > 0
					)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationListForStaff, (lesson) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: lesson.date,
                            class: "mb-10"
                          }, [
                            _createElementVNode("div", _hoisted_61, _toDisplayString(lesson.tag), 1),
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _hoisted_64,
                                _createElementVNode("div", _hoisted_65, [
                                  _createElementVNode("div", _hoisted_66, _toDisplayString(lesson.sent_count || 0), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                _hoisted_68,
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, _toDisplayString(lesson.draft_count || 0), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, [
                                  _createElementVNode("table", _hoisted_74, [
                                    _hoisted_75,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lesson.notices, (item, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          onClick: _withModifiers(($event: any) => (
													_ctx.$router.push(
														`/notifications/${item?.id}`
													)
												), ["stop"]),
                                          key: item.id,
                                          class: _normalizeClass([
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												, "text-neutral-700 cursor-pointer hover:bg-orange-50"])
                                        }, [
                                          _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_77, _toDisplayString(index + 1), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_78, [
                                            _createElementVNode("div", null, _toDisplayString(item?.title), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_79, [
                                            _createElementVNode("div", _hoisted_80, [
                                              (
																item.state !==
																'draft'
															)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_81, _hoisted_83))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_84, _hoisted_86))
                                            ])
                                          ]),
                                          _createElementVNode("td", _hoisted_87, [
                                            _createElementVNode("div", null, _toDisplayString(item?.subject), 1)
                                          ]),
                                          _createElementVNode("td", _hoisted_88, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("span", null, _toDisplayString(item.view_count ||
																'0') + " / " + _toDisplayString(item.total_parent_received ||
																'0'), 1)
                                            ])
                                          ]),
                                          _createElementVNode("td", _hoisted_89, [
                                            (item?.inserted_at)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_ctx.$filters.formatDateDDMM(
																item?.inserted_at
															)), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_91, "-"))
                                          ]),
                                          _createElementVNode("td", _hoisted_92, [
                                            (item?.sent_at)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.$filters.formatDateDDMM(
																item?.sent_at
															)), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_94, "-"))
                                          ])
                                        ], 10, _hoisted_76))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        }), 128)),
                        (_ctx.isInfinityLoading)
                          ? (_openBlock(), _createBlock(_component_DaInfinityLoading, {
                              key: 0,
                              onInfiniteLoad: _cache[11] || (_cache[11] = ($event: any) => (
							_ctx.tab === 0
								? _ctx.getNotificationList
								: _ctx.getNotificationListForStaff
						)),
                              loaded: _ctx.stopLoad
                            }, null, 8, ["loaded"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_95, _hoisted_98))
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_99, [
            _createVNode(_component_Loading)
          ]))
    ])
  ], 64))
}